<template>
    <div class="invite">
        <section>
            <div v-if="render">
                <div class="page-header header-fixed">
                    <div class="container">
                        <header>
                            <h1 v-if="coach">
                                <template>{{ __('Edit dietitian details') }}</template>
                                {{ __('(step :step out of :steps)', { step: 2, steps: 2}) }}
                            </h1>
                            <h1 v-else>{{ __('New dietitian') }} {{ __('(step :step out of :steps)', { step: 2, steps: 2}) }}</h1>
                        </header>
                        <div class="header-buttons">
                            <!-- Validate form then proceed to the next step -->
                            <VButton :label="__('Back')" variant="secondary" size="sm" @onClick="$emit('step', { nextStep: 1 })" />
                            <VButton :label="coach ? __('Confirm changes') : __('Send invitation')" type="submit" :disabled="!isValid" size="sm" @onClick="submit" />
                        </div>
                    </div>
                </div>
                <div class="availability-content">
                    <div>
                        <div class="availability-header">
                            <h2>{{ __('Fixed weekly availability') }}</h2>
                            <div class="input-wrapper form-input-datepicker">
                                <label class="fl-label checkbox-label" for="end-date-input">{{ __('Start of therapy') }}</label>
                                <input
                                    id="start-date-input"
                                    autocomplete="off"
                                    class="input-datepicker basic-border datepicker-start-date"
                                    name="start_date"
                                    required
                                    type="text"
                                />
                                <span class="material-symbols-rounded icon-close">
                                    <!-- TODO material icons close -->
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 5.95625L1.925 9.03125C1.7875 9.16875 1.63125 9.2375 1.45625 9.2375C1.28125 9.225 1.125 9.15 0.9875 9.0125C0.85 8.875 0.78125 8.71875 0.78125 8.54375C0.78125 8.35625 0.85 8.19375 0.9875 8.05625L4.04375 5L0.96875 1.925C0.83125 1.7875 0.7625 1.63125 0.7625 1.45625C0.775 1.26875 0.85 1.10625 0.9875 0.968749C1.125 0.831249 1.28125 0.762499 1.45625 0.762499C1.64375 0.762499 1.80625 0.831249 1.94375 0.968749L5 4.04375L8.075 0.968749C8.2125 0.831249 8.36875 0.762499 8.54375 0.762499C8.73125 0.762499 8.89375 0.831249 9.03125 0.968749C9.16875 1.10625 9.2375 1.26875 9.2375 1.45625C9.2375 1.63125 9.16875 1.7875 9.03125 1.925L5.95625 5L9.03125 8.075C9.16875 8.2125 9.2375 8.36875 9.2375 8.54375C9.2375 8.71875 9.16875 8.875 9.03125 9.0125C8.89375 9.15 8.73125 9.21875 8.54375 9.21875C8.36875 9.21875 8.2125 9.15 8.075 9.0125L5 5.95625Z" fill="#FF3E57"/>
                                    </svg>
                                </span>
                                <span class="material-symbols-rounded icon-calendar">
                                    <!-- TODO material icons calendar_month -->
                                    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.05 15.2C1.675 15.2 1.35625 15.0687 1.09375 14.8062C0.83125 14.5312 0.7 14.2125 0.7 13.85V3.95C0.7 3.5875 0.83125 3.275 1.09375 3.0125C1.35625 2.7375 1.675 2.6 2.05 2.6H3.4V1.475C3.4 1.2875 3.4625 1.13125 3.5875 1.00625C3.725 0.868749 3.8875 0.799999 4.075 0.799999C4.2625 0.799999 4.41875 0.868749 4.54375 1.00625C4.68125 1.13125 4.75 1.2875 4.75 1.475V2.6H9.25V1.475C9.25 1.2875 9.3125 1.13125 9.4375 1.00625C9.575 0.868749 9.7375 0.799999 9.925 0.799999C10.1125 0.799999 10.2688 0.868749 10.3938 1.00625C10.5313 1.13125 10.6 1.2875 10.6 1.475V2.6H11.95C12.325 2.6 12.6438 2.7375 12.9063 3.0125C13.1688 3.275 13.3 3.5875 13.3 3.95V13.85C13.3 14.2125 13.1688 14.5312 12.9063 14.8062C12.6438 15.0687 12.325 15.2 11.95 15.2H2.05ZM2.05 13.85H11.95V7.1H2.05V13.85ZM2.05 5.75H11.95V3.95H2.05V5.75ZM2.05 5.75V3.95V5.75ZM7 9.8C6.8125 9.8 6.65 9.7375 6.5125 9.6125C6.3875 9.475 6.325 9.3125 6.325 9.125C6.325 8.9375 6.3875 8.78125 6.5125 8.65625C6.65 8.51875 6.8125 8.45 7 8.45C7.1875 8.45 7.34375 8.51875 7.46875 8.65625C7.60625 8.78125 7.675 8.9375 7.675 9.125C7.675 9.3125 7.60625 9.475 7.46875 9.6125C7.34375 9.7375 7.1875 9.8 7 9.8ZM4.075 9.8C3.8875 9.8 3.725 9.7375 3.5875 9.6125C3.4625 9.475 3.4 9.3125 3.4 9.125C3.4 8.9375 3.4625 8.78125 3.5875 8.65625C3.725 8.51875 3.8875 8.45 4.075 8.45C4.2625 8.45 4.41875 8.51875 4.54375 8.65625C4.68125 8.78125 4.75 8.9375 4.75 9.125C4.75 9.3125 4.68125 9.475 4.54375 9.6125C4.41875 9.7375 4.2625 9.8 4.075 9.8ZM9.925 9.8C9.7375 9.8 9.575 9.7375 9.4375 9.6125C9.3125 9.475 9.25 9.3125 9.25 9.125C9.25 8.9375 9.3125 8.78125 9.4375 8.65625C9.575 8.51875 9.7375 8.45 9.925 8.45C10.1125 8.45 10.2688 8.51875 10.3938 8.65625C10.5313 8.78125 10.6 8.9375 10.6 9.125C10.6 9.3125 10.5313 9.475 10.3938 9.6125C10.2688 9.7375 10.1125 9.8 9.925 9.8ZM7 12.5C6.8125 12.5 6.65 12.4375 6.5125 12.3125C6.3875 12.175 6.325 12.0125 6.325 11.825C6.325 11.6375 6.3875 11.4812 6.5125 11.3562C6.65 11.2187 6.8125 11.15 7 11.15C7.1875 11.15 7.34375 11.2187 7.46875 11.3562C7.60625 11.4812 7.675 11.6375 7.675 11.825C7.675 12.0125 7.60625 12.175 7.46875 12.3125C7.34375 12.4375 7.1875 12.5 7 12.5ZM4.075 12.5C3.8875 12.5 3.725 12.4375 3.5875 12.3125C3.4625 12.175 3.4 12.0125 3.4 11.825C3.4 11.6375 3.4625 11.4812 3.5875 11.3562C3.725 11.2187 3.8875 11.15 4.075 11.15C4.2625 11.15 4.41875 11.2187 4.54375 11.3562C4.68125 11.4812 4.75 11.6375 4.75 11.825C4.75 12.0125 4.68125 12.175 4.54375 12.3125C4.41875 12.4375 4.2625 12.5 4.075 12.5ZM9.925 12.5C9.7375 12.5 9.575 12.4375 9.4375 12.3125C9.3125 12.175 9.25 12.0125 9.25 11.825C9.25 11.6375 9.3125 11.4812 9.4375 11.3562C9.575 11.2187 9.7375 11.15 9.925 11.15C10.1125 11.15 10.2688 11.2187 10.3938 11.3562C10.5313 11.4812 10.6 11.6375 10.6 11.825C10.6 12.0125 10.5313 12.175 10.3938 12.3125C10.2688 12.4375 10.1125 12.5 9.925 12.5Z" fill="#827F9B"/>
                                    </svg>
                                </span>
                            </div>
                        </div>

                        <div class="calendar">
                            <Calendar without-dates />
                        </div>
                    </div>

                    <div class="availability-info">
                        <div>
                            <span>{{ __('Selected hours') }}</span>
                            <strong>{{ numberFormat(countSelectedHours, 1) }} {{ __('hr') }}</strong>
                        </div>

                        <div v-if="data.isNotEmpty()" class="availability-total">
                            <span>{{ __('Fixed availability') }}</span>
                            <strong>{{ numberFormat(countMonthDuration, 1) }} {{ __('h/month') }}</strong>
                        </div>

                        <div v-if="countSelectedHours > 0" class="info-summary">
                            <strong class="summary-title">{{ __('Hour total') }}</strong>
                            <div class="summary-time">
                                <div v-for="{ type, date, times } in summarySlotsParser" :key="type + date">
                                    <div v-for="([start_time, end_time], i) in times" :key="i" class="info-changes exchange">
                                        <p>
                                            {{ moment(date).format('dddd') | capitalize }} {{ start_time.format('LT') }} -
                                            {{ end_time.format('LT') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Calendar from '@/components/Calendar/Calendar.vue'
import SlotsParser from '@/core/SlotsParser'
import Collection from '@/core/Collection'

export default {
    components: {
        Calendar
    },
    props: {
        coach: {
            type: Object,
            required: false,
            default: null
        },
        openingHours: {
            type: Array,
            required: false,
            default: null
        }
    },
    data() {
        return {
            render: false,
            startDate: moment().format('YYYY-MM-DD')
        }
    },
    computed: {
        ...mapGetters({
            slotsGrid: 'general/slotsGrid'
        }),
        data() {
            return this.slotsGrid.get().where('type', 'opening_hours')
        },
        // for backend slots must be converted to 5 minutes long slots
        convertedData() {
            return this.slotsGrid.convertForBackend(this.slotsGrid.get().all())
        },
        // creates summary from selected slots
        summarySlotsParser() {
            return SlotsParser.use(this.data).toTimeCollection()
        },
        // counts duration of selected slots
        countSelectedHours() {
            return SlotsParser.use(this.data).getDuration()
        },
        // counts duration for the whole month of selected slots
        countMonthDuration() {
            return SlotsParser.use(this.getMonthOfSlotsParser()).getDuration()
        },
        isValid() {
            return this.countSelectedHours > 0 && this.startDate
        }
    },
    created() {
        this.slotsGrid.setMode('opening_hours')

        if (this.openingHours) {
            // use existing opening hours
            this.slotsGrid.set(this.openingHours)
        } else {
            // get basic template for opening hours
            this.slotsGrid.set(this.getEmptyBaseCalendar())
        }

        this.render = true
    },
    mounted() {
        this.slotsGrid.setOption('tooltip-table', {
            opening_hours: lang.get('Remove the selected term'),
            default: lang.get('Choose a new time')
        })

        $(() => {
            const $datepicker = $(this.$el).find('.datepicker-start-date')

            $datepicker.datepicker({
                format: 'd. MM yyyy',
                language: _.get(window, 'locale', 'cs'),
                autoclose: true,
                container: '.form-input-datepicker',
                templates: {
                    rightArrow:
                    `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8 10.75L9.475 12.075C9.34167 12.225 9.275 12.4 9.275 12.6C9.275 12.8 9.34167 12.975 9.475 13.125C9.625 13.2583 9.8 13.325 10 13.325C10.2167 13.325 10.3917 13.2583 10.525 13.125L13 10.625C13.1833 10.4417 13.275 10.2333 13.275 10C13.275 9.76667 13.1833 9.55833 13 9.375L10.525 6.875C10.375 6.74167 10.2 6.675 10 6.675C9.8 6.675 9.625 6.74167 9.475 6.875C9.34167 7.00833 9.275 7.18333 9.275 7.4C9.275 7.61667 9.34167 7.79167 9.475 7.925L10.8 9.25H7C6.78333 9.25 6.6 9.325 6.45 9.475C6.31667 9.60833 6.25 9.78333 6.25 10C6.25 10.2167 6.31667 10.4 6.45 10.55C6.6 10.6833 6.78333 10.75 7 10.75H10.8ZM10 19.5C8.68333 19.5 7.44167 19.25 6.275 18.75C5.125 18.25 4.125 17.575 3.275 16.725C2.425 15.875 1.75 14.875 1.25 13.725C0.75 12.5583 0.5 11.3167 0.5 10C0.5 8.68333 0.75 7.45 1.25 6.3C1.75 5.13333 2.425 4.125 3.275 3.275C4.125 2.425 5.125 1.75 6.275 1.25C7.44167 0.749999 8.68333 0.499999 10 0.499999C11.3167 0.499999 12.55 0.749999 13.7 1.25C14.8667 1.75 15.875 2.425 16.725 3.275C17.575 4.125 18.25 5.13333 18.75 6.3C19.25 7.45 19.5 8.68333 19.5 10C19.5 11.3167 19.25 12.5583 18.75 13.725C18.25 14.875 17.575 15.875 16.725 16.725C15.875 17.575 14.8667 18.25 13.7 18.75C12.55 19.25 11.3167 19.5 10 19.5ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#5937B7"/></svg>`,
                    leftArrow:
                    `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.2 10.75H13C13.2167 10.75 13.3917 10.6833 13.525 10.55C13.675 10.4 13.75 10.2167 13.75 10C13.75 9.78333 13.675 9.60833 13.525 9.475C13.3917 9.325 13.2167 9.25 13 9.25H9.2L10.525 7.925C10.6583 7.79167 10.725 7.61667 10.725 7.4C10.725 7.18333 10.6583 7.00833 10.525 6.875C10.3917 6.74167 10.2167 6.675 10 6.675C9.78333 6.675 9.60833 6.74167 9.475 6.875L7 9.375C6.81667 9.55833 6.725 9.76667 6.725 10C6.725 10.2333 6.81667 10.4417 7 10.625L9.475 13.125C9.625 13.2583 9.8 13.325 10 13.325C10.2167 13.325 10.3917 13.2583 10.525 13.125C10.6583 12.975 10.725 12.8 10.725 12.6C10.725 12.3833 10.6583 12.2083 10.525 12.075L9.2 10.75ZM10 19.5C8.68333 19.5 7.44167 19.25 6.275 18.75C5.125 18.25 4.125 17.575 3.275 16.725C2.425 15.875 1.75 14.875 1.25 13.725C0.75 12.5583 0.5 11.3167 0.5 10C0.5 8.68333 0.75 7.45 1.25 6.3C1.75 5.13333 2.425 4.125 3.275 3.275C4.125 2.425 5.125 1.75 6.275 1.25C7.44167 0.749999 8.68333 0.499999 10 0.499999C11.3167 0.499999 12.55 0.749999 13.7 1.25C14.8667 1.75 15.875 2.425 16.725 3.275C17.575 4.125 18.25 5.13333 18.75 6.3C19.25 7.45 19.5 8.68333 19.5 10C19.5 11.3167 19.25 12.5583 18.75 13.725C18.25 14.875 17.575 15.875 16.725 16.725C15.875 17.575 14.8667 18.25 13.7 18.75C12.55 19.25 11.3167 19.5 10 19.5ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#5937B7"/></svg>`,
                }
            })
                .on('changeDate', ({ date }) => {
                    console.log(date)
                    this.startDate = moment(date).format('YYYY-MM-DD')
                })

            if (!_.isEmpty(this.coach)) {
                $datepicker.datepicker('setDate', moment(this.coach.start_date).toDate())
            } else {
                console.log('Hello')
                $datepicker.datepicker('setDate', moment(this.startDate).toDate())
            }
        })
    },
    methods: {
        getEmptyBaseCalendar() {
            const data = []
            const date = moment().startOf('week')

            _.times(7, () => {
                data.push({
                    type: 'opening_hours',
                    date: date.format('YYYY-MM-DD'),
                    slots: []
                })
                date.add(1, 'days')
            })

            return data
        },
        timeslotsToDay() {
            const template = {}

            this.data.each(({ date, slots }) => {
                let day = moment(date).day()
                if (day === 0) {
                    day = 7
                }

                template[day] = slots
            })

            return template
        },
        getMonthOfSlotsParser() {
            const monthTemplate = []
            const endOfMonthDate = moment()
                .endOf('month')
                .date()
            const template = this.timeslotsToDay()
            const date = moment().startOf('month')

            for (let i = 1; i <= endOfMonthDate; i++) {
                let day = date.day()
                if (day === 0) {
                    day = 7
                }

                monthTemplate.push({
                    type: 'opening_hours',
                    date: date.format('YYYY-MM-DD'),
                    slots: template[day] || []
                })

                date.add(1, 'days')
            }

            return new Collection(monthTemplate)
        },
        submit() {
            this.$emit('step', {
                data: {
                    opening_hours: this.convertedData,
                    start_date: this.startDate
                },
                nextStep: 3
            })
        }
    }
}
</script>
